import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  LoadingController,
  ModalController,
  ActionSheetController,
} from 'ionic-angular';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as moment from 'moment';
import { FeedPreset } from '../../providers/posts/posts';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ConfigProvider } from '../../providers/config/config';
import { UserProvider } from '../../providers/user/user';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';
import { ToolsProvider } from '../../providers/tools/tools';
import { UiToolsProvider } from '../../providers/ui-tools/ui-tools';
import { App } from 'ionic-angular';
import { NewsBrowserProvider } from '../../providers/news-browser/news-browser';
import { HintsProvider } from '../../providers/hints/hints';

declare let CmKit: any;

@IonicPage()
@Component({
  selector: 'page-news',
  templateUrl: 'news.html',
})
export class NewsPage {
  log = debug('app:NewsPage');
  
  feedPreset = FeedPreset;
  mode = 'latest';
  greeting = '';

  tabs = [
    {
      id: 'latest',
      label: 'Latest',
      title: 'Top News',
      refreshable: true,
    },
    {
      id: 'trending',
      label: 'Top Stories',
      title: 'Trending Stories',
      refreshable: true,
    },
    { id: 'videos', label: 'Videos', title: 'Videos', refreshable: true },
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public crudApi: CrudApiProvider,
    public configs: ConfigProvider,
    public user: UserProvider,
    public geolocation: GeolocationProvider,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public tools: ToolsProvider,
    public appCtrl: App,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public uiTools: UiToolsProvider,
    public newsBrowser: NewsBrowserProvider,
    public hints: HintsProvider
  ) {}

  ngOnInit() {
    const morningStart = 4;
    const morningEnd = 12;
    const eveningStart = 17;
    const currentHour = parseFloat(moment().format('HH'));

    console.log('current hour', currentHour);

    if (currentHour >= morningStart && currentHour < morningEnd) {
      this.greeting = 'Morning';
    } else if (currentHour >= morningEnd && currentHour < eveningStart) {
      this.greeting = 'Afternoon';
    } else {
      this.greeting = 'Evening';
    }

    // Fire the tab bar hints
    this.hints.tabBarReady.emit();
  }

  stopEvent(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  filterLikes(d) {
    return d.engagementType === 'LIKE';
  }

  reloadFeed(event) {
    if (event.tab && event.tab.feed) {
      event.tab.feed.refresh(event.refresher);
    } else {
      event.refresher && event.refresher.complete();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/news/news.ts